var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "71px",
    viewBox: "0 0 80 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "t-warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "failure",
    transform: "translate(-729.000000, -265.000000)",
    fill: "#FF5722",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t-warning",
    transform: "translate(729.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.665063,66.7432719 L42.1650034,1.1705106 C41.6830389,0.439360918 40.8703868,5.60002995e-16 40,0 C39.1296132,-1.12000599e-15 38.3169611,0.439360918 37.8349966,1.1705106 L0.334937023,66.7432719 C-0.111640002,67.5235805 -0.111646054,68.484959 0.334921145,69.2652734 C0.781488344,70.0455878 1.60678641,70.5262929 2.49994046,70.5263158 L77.5000595,70.5263158 C78.3932136,70.5262929 79.2185117,70.0455878 79.6650789,69.2652734 C80.1116461,68.484959 80.11164,67.5235805 79.665063,66.7432719 Z M44.2850068,22.6077595 L42.500004,47.8280523 L37.499996,47.8280523 L35.7149932,22.6077595 L44.2850068,22.6077595 Z M40,62.960228 C37.5450904,62.960228 35.5549929,60.9525975 35.5549929,58.4760599 C35.5549929,55.9995223 37.5450904,53.9918918 40,53.9918918 C42.4549096,53.9918918 44.4450071,55.9995223 44.4450071,58.4760599 C44.4450071,60.9525975 42.4549096,62.960228 40,62.960228 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.510cd7141828147cac6b575fcaeddc14.svg";
export { ForwardRef as ReactComponent };